import { ClickableTextItem } from "@/Common/Api/ClickableText/Dto/ClickableTextItem";
import { Service } from "@/Common/Api/Services/Dto/Responses/Service";
import { Guid } from "@/Common/Models/Guid";

class EmployeeGroup {
    public Id: Guid;
    public Name: string;
    public IsInactive: boolean;
    public EmployeeContactFacetIds: Guid[];

    public IsSharingResults: boolean;
    public AllowedTags: string[];
    public UsefulLinks: string[];
    public SiteIds: string[];
    public Permissions: string[];
    public ServicesIDsOffered: Service[];
    public MessagesSharing: string[];
    public TasksSharing: string[];
    public ClickableText: ClickableTextItem[] = [];
    public Transfertdate: Date;
    public CreatedBy: string;
    public CreationDate: Date;

    // Not in DB
    public IsHighlighted: boolean;

    constructor() {
        this.Id = null;
        this.Name = "";
        this.IsInactive = false;
        this.EmployeeContactFacetIds = [];

        this.IsSharingResults = false;
        this.AllowedTags = [];
        this.UsefulLinks = [];
        this.SiteIds = [];
        this.Permissions = [];
        this.ServicesIDsOffered = [];
        this.MessagesSharing = [];
        this.TasksSharing = [];
        this.ClickableText = [];
        this.CreatedBy = "";
    }
}

export { EmployeeGroup };
